import styles from './VerticalSystemModal.module.scss';

import React, { FC } from 'react';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { FlatResponsiveImage } from 'components/FlatResponsiveImage/FlatResponsiveImage';
import { IconType } from 'components/Icon/Icon';
import { IconButton } from 'components/IconButton/IconButton';
import { Modal } from 'components/Modal/Modal';
import { TextV2 } from 'components/TextV2/TextV2';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { toEntry } from 'services/cms/typesUtil';
import { VerticalSystemTabItem } from '../types';

type VerticalSystemModalProps = {
  activeItem?: VerticalSystemTabItem['items'][0];
  onRequestClose?: () => void;
};

export const VerticalSystemModal: FC<VerticalSystemModalProps> = ({ activeItem, onRequestClose }) => {
  return (
    <Modal
      isOpen={!!activeItem}
      onRequestClose={onRequestClose}
      className={styles.root}
      overlayClassName={styles.overlay}
    >
      {activeItem && (
        <>
          <div className={styles.heading}>
            <FlatResponsiveImage
              image={activeItem.icon}
              className={styles.image}
              pictureProps={{ className: styles.picture }}
            />
            <TextV2 variant="modern-h4" value={activeItem.title} className={styles.title} />
            <IconButton type={IconType.CLOSE} className={styles.closeButton} onClick={onRequestClose} />
          </div>
          <TextV2 variant="modern-body" value={activeItem.description} className={styles.description} />
          {activeItem.link && (
            <ContentLinkV2 entry={toEntry(activeItem.link)} className={styles.link} hideTitle>
              <TextWithArrow theme="light-purple">{activeItem.link.title}</TextWithArrow>
            </ContentLinkV2>
          )}
        </>
      )}
    </Modal>
  );
};
